import $ from "jquery";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "limitUnit",
    "receptionUnit",
    "ticketUnit",
    "receptionRadio",
    "receptionRadio2",
    "applicationLimitRadio",
    "applicationLimitRadio1",
  ];

  static values = { isApplicationLimitEnabled: String, applicationLimit: String };

  connect() {
    const noLimit = document.getElementById("no_limit");
    if (["per_event", "per_performance", "per_reception", "per_ticket"].includes(noLimit.dataset.value)) {
      document.getElementById("set_limit").checked = true;
      noLimit.checked = false;
      this.show(this.limitUnitTarget);
      this.handleUnitSwitch(noLimit.dataset.value);
    } else {
      document.getElementById("no_limit").checked = true;
    }
  }
  toggleLimit() {
    const isLimitEnabled =
      this.element.querySelector("input[name='application_limit_form[is_application_limit_enabled]']:checked").value ===
      "true";

    if (isLimitEnabled) {
      this.show(this.limitUnitTarget);
      this.applicationLimitRadioTargets.forEach((radio) => {
        if (radio.checked) {
          // チェックされたラジオボタンの値に応じて処理を行う
          if (radio.value === "per_reception") {
            this.enableInputs(this.receptionUnitTarget);
          } else if (radio.value === "per_ticket") {
            this.enableInputs(this.ticketUnitTarget);
          }
        }
      });
    } else {
      this.hide(this.limitUnitTarget);
      this.disableInputs(this.receptionUnitTarget);
      this.disableInputs(this.ticketUnitTarget);
      this.applicationLimitValue = "no_limit";
    }
  }

  toggleUnit(event) {
    const selectedValue = event.target.value;
    this.applicationLimitValue = selectedValue;
    this.handleUnitSwitch(selectedValue);
  }

  confirmDialog(e) {
    switch (this.applicationLimitValue) {
      case "no_limit": // 制限なし
        e.preventDefault();
        this.showDialog("no_limit_dialog");
        break;
      case "per_event": // イベント単位
        e.preventDefault();
        this.showDialog("per_event_dialog");
        break;
      case "per_reception": // 受付単位
        e.preventDefault();
        this.showDialog("per_reception_dialog");
        break;
      case "per_ticket": // チケット単位
        e.preventDefault();
        this.showDialog("per_ticket_dialog");
        break;
      default:
    }
  }

  showDialog(targetId) {
    const target = document.getElementById(targetId);
    const modalController = this.application.getControllerForElementAndIdentifier(target, "modal");
    modalController.show();
  }

  submitForm() {
    const form = document.querySelector("#application_limit_form");
    form.submit();
  }

  handleUnitSwitch(value) {
    switch (value) {
      case "per_event": // イベント単位
        document.getElementById("per_event").checked = true;
        this.hide(this.receptionUnitTarget);
        this.hide(this.ticketUnitTarget);
        this.disableInputs(this.receptionUnitTarget);
        this.disableInputs(this.ticketUnitTarget);
        break;
      case "per_reception": // 受付単位
        document.getElementById("per_reception").checked = true;
        this.show(this.receptionUnitTarget);
        this.hide(this.ticketUnitTarget);
        this.enableInputs(this.receptionUnitTarget);
        this.disableInputs(this.ticketUnitTarget);
        break;
      case "per_ticket": // チケット単位
        document.getElementById("per_ticket").checked = true;
        this.hide(this.receptionUnitTarget);
        this.show(this.ticketUnitTarget);
        this.enableInputs(this.ticketUnitTarget);
        this.disableInputs(this.receptionUnitTarget);
        break;
      default:
        this.hide(this.receptionUnitTarget);
        this.hide(this.ticketUnitTarget);
    }
  }

  show(element) {
    $(element).slideDown(10);
  }

  hide(element) {
    $(element).slideUp(10);
  }

  disableInputs(element) {
    $(element).find("input").prop("disabled", true);
  }

  enableInputs(element) {
    $(element).find("input").prop("disabled", false);
  }
}
